module.exports = __webpack_public_path__ + "img/brands-models-2.ad688c51.jpg";